import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { BaseComponent } from '@portals/core';
import { Editor, toDoc, Toolbar } from 'ngx-editor';
import { toHTML } from 'ngx-editor';
import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';

@Component({
	selector: 'portals-text-editor',
	templateUrl: './text-editor.component.html',
	styleUrls: ['./text-editor.component.scss'],
})
export class TextEditorComponent extends BaseComponent implements OnDestroy {
	editor: Editor;
	@Input() htmlText!: string;
	@Input() placeholder!: string;
	@Output() textEmitter = new EventEmitter();

	toolbar: Toolbar = [['bold', 'italic'], ['underline', 'strike'], ['code', 'blockquote'], ['ordered_list', 'bullet_list'], [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }], ['link'], ['text_color'], ['align_left', 'align_center', 'align_right', 'align_justify']];

	constructor() {
		super();
		this.editor = new Editor();
	}

	override ngOnDestroy(): void {
		this.editor.destroy();
	}

	onChange(html: any) {
		this.htmlText ? ((html = toDoc(html)), this.textEmitter.emit(toHTML(html))) : this.textEmitter.emit(toHTML(html));
	}
}
